import React from "react";
import { useEffect, useState } from "react";
import { EmployeeRecordsVM } from "../../Models/ViewModels";
import * as Employee from "../../Services/EmployeeDB";
import { ToastContainer, toast } from 'react-toastify';
import { AnyPtrRecord } from "dns";
import { GetUserLoginID } from "../../Services/UserSessionManager";
import { Row, Table } from "rsuite";
import { CustomTableHeaderCell } from '../../SharedComponents/CustomTableHeaderCell';
import { CustomTableCell } from '../../SharedComponents/CustomTableCell';
const { Column, HeaderCell, Cell, ColumnGroup } = Table;
export const EmployeeDetails = (props: any) => {
  const [cachedEmployeesList, setCachedEmployeesList] = useState(new Array<EmployeeRecordsVM>())
  const [loginid, setLoginid] = useState(GetUserLoginID())
    

  const getEmployeeRecords = (id: any) => {

    Employee.GetEmployeeRecords(id).then(res => {
      if (res.data) {
        console.log(res.data)
        setCachedEmployeesList(res.data);
      }

    }).catch(err => {
      console.log(err)
    })
  }
  useEffect(() => {
    getEmployeeRecords(props.id);
  }, [])
  return <>
    {
      cachedEmployeesList && cachedEmployeesList.length > 0 &&

      <div >
  <table className="table1">
    <tr><h5>Employee Detail </h5></tr>
  <tr>
    <th>Id</th>
    <td>{cachedEmployeesList[0].EmployeeOfficeBadgeId}</td>
  </tr>
  <tr>
    <th>Employee Role</th>
    <td>{cachedEmployeesList[0].EmployeeRole}</td>
   
  </tr>
  <tr>
    <th>Department</th>
    <td>{cachedEmployeesList[0].Department}</td>

  </tr>
  <tr>
  <th>Gender</th>
    <td>{cachedEmployeesList[0].Gender}</td>
   
  </tr>
  <tr>
  <th>Date Of Joining</th>
    <td>{cachedEmployeesList[0].Doj.substring(0,cachedEmployeesList[0].Doj.indexOf('T'))}</td>
   
  </tr>
  <tr>
  <th>Employment Type</th>
    <td>{cachedEmployeesList[0].EmploymentType}</td>
   
  </tr>
  <tr>
  <th>Employee Email</th>
    <td>{cachedEmployeesList[0].EmployeeEmail}</td>
   
  </tr>
  <tr>
  <th>Employee Designation</th>
    <td>{cachedEmployeesList[0].EmployeeDesignation}</td>
   
  </tr>
  <tr>
  <th>Office Location</th>
    <td>{cachedEmployeesList[0].OfficeLocation}</td>
    
  </tr>
  <tr>
  <th>WorkShift</th>
    <td>{cachedEmployeesList[0].WorkShift}</td>
   
  </tr>
  <tr>
  <th>Production Role</th>
    <td>{cachedEmployeesList[0].ProductionRole}</td>
  </tr>
  <tr>
  <th>Prev. Relevant Exp. (months)</th>
    <td>{cachedEmployeesList[0].RCMTenurity}</td>
   
  </tr>
 <tr>
  <th>Overall Relevant Exp. (Years)</th>
    <td>{cachedEmployeesList[0].Tenurity_in_Project}</td>
  </tr>
</table>
   </div> 
}
  </>
}